import React from 'react';
import DataSourcesPage from './DataSourcesPage';

const AnimalTypesPage: React.FC = () => (
  <DataSourcesPage
    title="Animal Types"
    itemLabel="Option"
    addButtonLabel="Add Option"
    source="ANIMAL TYPE"
    columns={[
      { key: 'name', label: 'Option' },
      { key: 'code', label: 'Code' },
      { key: 'label', label: 'Label' },
      { key: 'sortOrder', label: 'Order' },
      { key: 'isActive', label: 'Status' }
    ]}
    fields={[
      { key: 'name', label: 'Option', required: true },
      { key: 'code', label: 'Code', required: true, help: 'The SP Code in the Animal Type export.' },
      {
        key: 'label',
        label: 'Label',
        help: 'What the crew reads, where it differs from the value above. Leave blank to use the value.'
      },
      { key: 'sortOrder', label: 'Order', control: 'number', help: 'Position within its question. 0 sorts last.' },
      { key: 'isActive', label: 'Active', control: 'checkbox', help: 'Clear this to retire the option without deleting it, so historic entries still resolve.' }
    ]}
  />
);

export default AnimalTypesPage;
